import React, { PropsWithChildren } from "react";
import { connect, FormikContext } from "formik";
import { Flex } from "rebass";

import { ControlButton } from "./ControlButton";

interface IProps {
  formik: FormikContext<{}>
}

const FormControlComponent: React.FC<IProps> = ({ formik }) => (
  <Flex
    height="100%"
    justifyContent="space-between"
    alignItems="center"
    px="8px"
    bg="sp-blue"
  >
    <ControlButton
      type="button"
      border="1px solid"
      borderColor="#fff"
      color="#fff"
      bg="transparent"
      onClick={formik.handleReset}
      disabled={formik.isSubmitting || !formik.dirty}
    >
      reset
    </ControlButton>

    <ControlButton
      type="submit"
      color="sp-blue"
      bg="#fff"
      disabled={formik.isSubmitting || !formik.isValid}
    >
      save
    </ControlButton>
  </Flex>
);

export const FormControl = connect<PropsWithChildren<{}>>(FormControlComponent);
